var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-container" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", "no-margin": "" } },
            [
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.selectedTab,
                  callback: function ($$v) {
                    _vm.selectedTab = $$v
                  },
                  expression: "selectedTab",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.selectedTab == 0
        ? _c("app-demo-statistics")
        : _vm.selectedTab == 1
        ? _c("app-sale-statistics")
        : _vm.selectedTab == 2
        ? _c("app-installations-statistics")
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }